// extracted by mini-css-extract-plugin
export default {"footer":"a-z","footerContainer":"b-z"};